import * as React from 'react';
import {Button, Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import inspectionConfirmImage from '../../assets/img/ic_inspection_confirm.png';
import PropTypes from 'prop-types';
import HorizontalLine from "../Widget/HorizontalLine";
// import label from "../../message/Label";
import label from 'enqc-utilities/src/label/Label'

import MyCardImage from "../Card/MyCardImage";


export default class ConfirmInspectionCloseModal extends React.Component{


    render(){
        let {inspection} = this.props
        return (
            <Modal
                centered={true}
                isOpen={this.props.showing}
                backdrop={true}>
                <ModalHeader>
                    {label.ConfirmSubmission}
                </ModalHeader>
                <ModalBody>
                    <Card>
                        <CardBody style={{textAlign:'center'}}>
                            <MyCardImage style={{width:'240px'}} src={inspectionConfirmImage}/>
                        </CardBody>
                    </Card>
                    <br/>
                    <div style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html: label.YouWillCloseInspectionWithReferenceVariable1AndSerialCodeVariable2_AreYouSure(inspection.reference,
                            inspection.serialCode?inspection.serialCode:"<p style=\"color:red\">Not Available</p>", label.CLoseStatus)}} />
                </ModalBody>
                <HorizontalLine/>
                <ModalBody>
                    <Row>
                        <Col>
                            <Button color="warning" onClick={e=>{
                                this.props.cancelCallback()
                            }}>
                                {label.Cancel}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                className={"float-right"}
                                color="primary" onClick={e=>{
                                this.props.okCallback()
                            }}>
                                {label.YesIamSure}
                            </Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        )
    }
}
ConfirmInspectionCloseModal.propTypes = {
    inspection:PropTypes.object.isRequired,
    inspectionEvent:PropTypes.object.isRequired,
    showing:PropTypes.bool.isRequired,
    okCallback:PropTypes.func.isRequired,
    cancelCallback:PropTypes.func.isRequired
}
